// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import New from './new.js'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import {Loading ,MessageBox ,Message} from 'element-ui';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css';
import IScrollView from 'vue-iscroll-view'
import IScroll from 'iscroll'
import VueVideoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import Utils from './utils'
import axios from "axios"
import Vueaxios from "vue-axios"
import dateTime from 'vue-date-time-m';
// import 'babel-polyfill';
import Print from 'vue-print-nb'
/* eslint-disable no-new */


Vue.use(Print)
Vue.use(dateTime)
Vue.use(ElementUI)
Vue.use(VueVideoPlayer)
Vue.use(IScrollView, IScroll)
Vue.use(VueAwesomeSwiper)
Vue.use(Vueaxios , axios )


let loadingInstance='';
function isMobile() {
    let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    return flag;
}
if (isMobile()) { //手机
    //a request interceptor
    axios.interceptors.request.use(function (config) {
        const token = Utils.token.get() || '';
        if ( config.url != '/api/Course/Chapter' && config.url != '/api/Course/Play'  && config.url != '/api/Index/IsQ'
        && config.url != '/api/Course/Times' && config.url != '/api/User/Check' && config.url != '/api/Course/Progress' 
        && config.url != '/api/Face/ContrastStatus' ) {
        loadingInstance = Loading.service({ fullscreen: true ,background:'rgba(0, 0, 0, 0.6)',spinner:'el-icon-loading'});
        }
        if (token != '' && token != undefined && token != null && token != 'undefined' && token != 'null') {
        config.headers.auth = token;
        }
        return config;
    }, function (err) {
        return Promise.reject(err);
    });
    axios.interceptors.response.use(function (response) {
        if (loadingInstance) {
            loadingInstance.close();
        }
        var urlRouter = response.request.responseURL.split('/api/')[1]
        if (response.data.code === 401) {
            router.push({name: 'IndexM'})
            if (urlRouter !== 'SignUp/GetCardID'){
                MessageBox.confirm('<div class="bgIconAlert"><i class="el-icon-warning"></i><div>'+response.data.msg+'</div></div>', '', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '关闭',
                    center: true
                }).then(()=>{
                    
                })
            }
        } else if(response.data.code !== 200) {
            if (urlRouter !== 'Course/Times' && urlRouter !== 'Course/Chapter'){
                MessageBox.confirm('<div class="bgIconAlert"><i class="el-icon-warning"></i><div>'+response.data.msg+'</div></div>', '', {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: '关闭',
                    center: true
                }).then(()=>{
                    
                })
            }
        }
    return response;
    }, function (error) {
        loadingInstance.close()
        if (error.response.status) {
            let statusC =  error.response.status
            if (error.config.url !== '/api/SignUp/OrderQuery') {
                if (statusC == 500 || statusC == 501 || statusC == 502 || statusC == 503  || statusC == 504 || statusC == 401) {
                    MessageBox.confirm('<div class="bgIconAlert"><i class="el-icon-warning"></i><div>错误提示'+statusC+'</div></div>', '', {
                        dangerouslyUseHTMLString: true,
                        confirmButtonText: '关闭',
                        center: true
                    }).then(()=>{
                        
                    })
                } 
            }
        }
        return Promise.reject(error);
    });

} else {
    //a request interceptor
    axios.interceptors.request.use(function (config) {
        if (config.url != '/api/index/Article' && config.url != '/api/SignUp/OrderQuery'  && config.url != '/api/Index/IsQ'
        && config.url != '/api/SignUp/GetYears'  && config.url != '/api/Course/Times' && config.url != '/api/SignUp/PostInvoice' 
        && config.url != '/api/SignUp/Invoice'  && config.url != '/api/Course/Chapter'  && config.url !=  '/api/SignUp/GetPayUrl' 
        && config.url != '/api/Course/Progress'  && config.url != '/api/Face/ContrastStatus') {
            loadingInstance = Loading.service({ fullscreen: true ,background:'rgba(0, 0, 0, 0.6)'});
        }
        
        return config;
        }, function (err) {
        return Promise.reject(err);
    });
    axios.interceptors.response.use(function (response) {
        //   window.scrollTo(0,0)
        if (loadingInstance) {
            loadingInstance.close()
        }

        var urlRouter = response.request.responseURL.split('/api/')[1]
        if (response.data.code === 401) {
            router.push({name: 'index'})
            if (urlRouter !== 'SignUp/GetCardID'){
                Message.error({
                    message: response.data.msg,
                });
            }
        } else if(response.data.code !== 200) {
            if (urlRouter !== 'Course/Times' && urlRouter !== 'Course/Chapter'){
                Message.error({
                    message: response.data.msg,
                });
            }
        }
    return response;
    }, function (error) {
        loadingInstance.close()
        if (error.response.status) {
            let statusC =  error.response.status
            if (error.config.url !== '/api/SignUp/OrderQuery') {
                if (statusC == 500 || statusC == 501 || statusC == 502 || statusC == 503  || statusC == 504 || statusC == 401) {
                    Message.error({
                        message:'错误提示'+statusC,
                    });
                } 
            }
        }
        return Promise.reject(error.config);
    });
}

Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js